import type { ReactNode } from 'react'
import { useQuery } from '@apollo/client/react'
import { useEffect } from 'react'
import { GQL_FIND_ORGANIZATION } from '~/gql/organizations/find-organization'
import { currentOrgSlug } from '~/helpers/apollo'
import { knownOrgRedirect, SYSTEM_ORG_SLUG } from '~/routes/orgRouting'

/**
 * N'ouvre l'écran de connexion d'une org que si elle existe (#346). L'API
 * habille un slug inconnu aux couleurs de l'org par défaut : sans ce contrôle,
 * `/o/nimporte-quoi/login` affichait la connexion d'un autre client.
 *
 * Une panne de la vérification laisse passer : mieux vaut l'écran d'avant que
 * pas d'écran du tout.
 */
function KnownOrgGate({ children }: { children: ReactNode }) {
  const slug = currentOrgSlug()
  const isPlatform = slug === SYSTEM_ORG_SLUG
  const { data, error } = useQuery(GQL_FIND_ORGANIZATION, { variables: { query: slug }, skip: isPlatform })
  const redirect = data ? knownOrgRedirect(new URL(window.location.href), data.findOrganization ?? null) : null

  useEffect(() => {
    if (redirect) window.location.replace(redirect)
  }, [redirect])

  if (isPlatform || error) return children
  if (!data || redirect) return null
  return children
}

export default KnownOrgGate
